import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },
  '& .checkout_stripe_payment': {
    '& .promo-spinner': {
      backgroundColor: 'unset',
    },
  },

  '& .headerHighlight': {
    color: palette.primary.main,
  },

  '.rootdfw-container': {
    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.header,
        '& .hero-header-title, & .hero-header-subtitle': {
          color: palette.text.highlight,
        },
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.footer,

      '& .home-hero-title': {
        fontWeight: 600
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
        padding: '0px 12px',

        '@media(min-width: 900px)': {
          padding: '40px 40px 80px',
          '& .home-hero-title': {
            fontSize: '48px',
          },
          '& .home-hero-subtitle': {
            fontSize: '18px',
            maxWidth: 520,
          },
        },
      },
      '& .login-button': {
        backgroundColor: palette.text.highlight,
        color: palette.secondary.main,
        borderColor: palette.secondary.main,
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,

        '@media(min-width: 900px)': {
          paddingTop: 120,
        },

        '& .section-alternate__content': {
          paddingBottom: 0,

          '@media(min-width: 900px)': {
            padding: '0px',
          },

          '& .section-header': {
            '@media(min-width: 900px)': {
              minHeight: 550,
            },
          },
        },
        '& .hero-title': {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: '55px',

          '@media(min-width: 600px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 64,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
            maxWidth: 600,
          },
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 900px)': {
            fontSize: 20,
          },
        },
        '& .MuiButton-label': {
          fontSize: 15,
          letterSpacing: '-0.03em',
        },
      },
      '& .hero-background': {
        objectFit: 'cover',
        '@media(max-width: 900px)': {
          display: 'none',
        }
      },
      '& .image-wrapper': {
        paddingBottom: 0,
        marginBottom: -5,

        '& .image': {
          '@media(min-width: 900px)': {
            height: 688,
            width: 'auto',
          },
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.footer,
    },
    '& .definition-variant-2': {
      paddingTop: '0 !important',
      paddingBottom: '0 !important',

      '@media(max-width: 900px)': {
        paddingTop: 0,
      },

      '& .benefits-wrapper': {
        '& .section-header__title': {
          paddingBottom: 64,

          '@media(max-width: 900px)': {
            paddingBottom: 24,
          },
        },
        '& .definition-service-title': {
          fontSize: 24,
          fontWeight: 600,
        },
        '& .definition-service-description-wrapper': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .definition-service-description': {
          fontSize: 16,
          fontWeight: 400,
          paddingBottom: 40,
          color: '#64748B',
          borderBottom: `1px solid #C9D5E0`,

          '@media(min-width: 900px)': {
            maxWidth: 350,
          },
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingLeft: '74px !important',
        },
        '& .definition-service-innertile': {
          width: 'calc(100% + 16px) !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .subscription-bg': {
        background: palette.background.main,
      },
      '& .section-header__title': {
        color: palette.text.highlight,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '& .section-header__subtitle': {
          color: palette.text.highlight,
          maxWidth: '580px',
        },
      },
      '& .subscription-tabs-label': {
        color: palette.text.highlight,
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          borderColor: palette.secondary.main,
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            borderColor: palette.secondary.main,
            color: palette.text.primary,
            background: palette.text.highlight,
            '& .customGetStarted': {
              color: palette.text.highlight,
            },
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
        },
        '& .customGetStarted': {
          color: palette.text.primary,
          '&:hover': {
            color: palette.text.highlight,
          }
        },
        '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
          background: palette.background.light,
          border: `1px solid ${palette.secondary.main}`,
          opacity: 1,
        },
        '& .MuiSwitch-track': {
          border: `1px solid ${palette.secondary.main}`,
          background: palette.text.highlight,
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: palette.secondary.main,
        },
        '& .summary-text, .summary-subtext': {
          color: palette.text.highlight,
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.highlight,
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .howitworks-title': {
        marginBottom: 0,
      },
      '& .section-header__subtitle-wrapper': {
        fontSize: 18,
        fontWeight: 400,
        color: '#5A5A5A',
      },
      '& .how-cover-image': {
        height: 550,
        borderRadius: 24,
        '@media(max-width: 900px)': {
          height: '100%',
        },
      },
      '& .step-content': {
        maxWidth: 400,
        color: '#5A5A5A',
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .working-steps-container': {
        paddingBottom: 24,
        marginBottom: 8,
        borderBottom: '1px solid #707d9433',

        '& .step-counter': {
          borderRadius: '36px',
          backgroundColor: palette.secondary.main,
          color: palette.text.highlight,
        },
        '& .step-title': {
          fontSize: 24,
          fontWeight: 500,
          letterSpacing: '-0.01em',
        },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingRight: 80,
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      background: palette.background.light,
      '& .section-header__title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .react-multi-carousel-list': {
        overflow: 'visible',

        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: 0,
          zIndex: 1,

          '@media(min-width: 600px)': {
            width: 350,
          },
          '@media(min-width: 900px)': {
            width: 450,
          },
          '@media(min-width: 1200px)': {
            width: 550,
          },
        },
        '&:before': {
          left: -115,
          background:
            'linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
        '&:after': {
          right: -130,
          background:
            'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
      },
      '& .patient-label': {
        fontWeight: 500,
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .savings-cell-1': {
        maxWidth: 400,
        whiteSpace: 'pre-wrap',
      },
      '& .service-plan-table': {
        borderColor: palette.secondary.main,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        backgroundColor: palette.background.primary,

        '& .footer-bar-text': {
          color: palette.text.highlight,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-title': {
        fontWeight: 'normal',
        letterSpacing: '-0.04em',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        background: palette.background.footer,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .planCard': {
        '&:hover': {
          color: palette.text.primary,
          backgroundColor: palette.text.highlight,
          '& .highlight-divider': {
            background: palette.divider,
          },
        },
      },
      '& .primary-static-button': {
        backgroundColor: palette.primary.main,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .react-multi-carousel-dot button': {
        backgroundColor: palette.primary.main,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.background.header}`,
        backgroundColor: palette.text.highlight,
        opacity: 1
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.background.header} !important`,
        background: `${palette.text.header} !important`,
        color: palette.secondary.main,
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: palette.background.header,
      },
      '& .MuiSvgIcon-colorPrimary': {
        color: palette.secondary.main,
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .termsLink': {
        color: palette.text.primary,
      },
      '& .icon-wrapper': {
        '& .groupIcon': {
          fill: palette.secondary.main
        }
      },
      '& .customAddMembersLink': {
        color: palette.text.primary,
      },
      '& .MuiCheckbox-colorPrimary.Mui-checked:not(.Mui-disabled)': {
        color: palette.secondary.main,
      }
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: 0,
        marginRight: 8,
      },
      '& .provider-contact-details': {
        fontSize: 18,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontSize: 24,
        fontWeight: 500,
      },
    },

    /* Subscription Success Page */
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .stepperContainer': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.secondary.main,
      },
      '& .stepperIconRoot': {
        color: palette.text.highlight,
        borderColor: palette.secondary.main,
      },
      '& .stepperIconText': {
        fill: palette.text.primary,
      },
      '& .stepperIconRoot.MuiStepIcon-active, .MuiStepIcon-completed': {
        color: palette.secondary.main,
        borderColor: palette.secondary.main,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .MuiStepIcon-text': {
        color: palette.text.highlight,
      },
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
    },
  },
};
